import { Alert, Col, Flex, Row, Switch, Typography } from "antd"
import { useTranslation } from "react-i18next"

import Button from "../../../../../Components/Button"
import InputNumber from "../../../../../Components/Input/InputNumber"
import Icon from "../../../../../Icon"

import dim from "./dimmed.module.less"
import styles from "./inlineNote.module.less"

const { Text } = Typography

const LowValueSection = ({ locked, fetching, isStripeUser, enabled, amount, onToggle, onEdit }) => {
  const { t } = useTranslation()

  return (
    <Row gutter={[24, 24]}>
      <Col flex="1 1 300px">
        <Flex vertical gap={8} style={{ maxWidth: 500 }}>
          <Text strong>{t("Ignore low-value disputes")}</Text>
          <Text type="secondary">
            {t(
              "Small disputes aren't always worth fighting. Recover leaves anything below your amount unsubmitted and marks it Skipped."
            )}
          </Text>
          {/* Precedence is the one thing merchants can't infer, so it stays. Carried in
              the compact primary callout (single line, no heading) rather than a plain
              strong line, so it reads as a system rule and not as more body copy. */}
          <Alert
            className={`${styles.note} ${styles.notePrimary}`}
            showIcon
            icon={<Icon type="circle_info" style={{ fontSize: 20 }} />}
            message={<Text>{t("This rule overrides all other rules.")}</Text>}
          />
          {isStripeUser ? (
            <Alert
              className={styles.note}
              showIcon
              icon={<Icon type="circle_info" style={{ fontSize: 20 }} />}
              message={<Text strong>{t("Recommended for Stripe")}</Text>}
              description={
                <Text>
                  {t(
                    "Stripe charges $15 upfront, and another $15 if you fight and lose. A $15 dispute rarely pays off to fight."
                  )}
                </Text>
              }
            />
          ) : null}
        </Flex>
      </Col>

      <Col flex="0 1 420px">
        <Flex vertical gap={24}>
          <Flex gap={12} align="center">
            <Switch checked={enabled} onChange={onToggle} disabled={fetching || locked} />
            <Text>{t("Skip low-value disputes instead of fighting them")}</Text>
          </Flex>

          <Flex vertical gap={8} className={locked || !enabled ? dim.dimmed : ""}>
            <Text>{t("Skip disputes below")}</Text>
            <Flex gap={12}>
              <InputNumber
                addonBefore={<Text type="secondary">$</Text>}
                // Toggle off = the feature does nothing, so the field reads 0.00.
                value={enabled ? Number(amount || 0) : 0}
                precision={2}
                disabled
                style={{ width: "100%" }}
              />
              <Button
                size="large"
                disabled={locked || !enabled}
                onClick={onEdit}
                text={t("Edit")}
              />
            </Flex>
            <Text type="secondary" style={{ fontSize: 14 }}>
              {t(
                "Applies to disputes that arrive from now on. Disputes already in your queue are left alone."
              )}
            </Text>
          </Flex>
        </Flex>
      </Col>
    </Row>
  )
}

export default LowValueSection
